import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function InfoAnnotationSvg() {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.5"
        cx="28"
        cy="28"
        r="28"
        fill="#99C49D"
        fillOpacity="0.5"
      />
      <path
        d="M28 45.5C18.335 45.5 10.5 37.665 10.5 28C10.5 18.335 18.335 10.5 28 10.5C37.665 10.5 45.5 18.335 45.5 28C45.5 37.665 37.665 45.5 28 45.5ZM28 48C39.0457 48 48 39.0457 48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48Z"
        fill="white"
      />
      <path
        d="M30.3268 24.4697L24.5992 25.1875L24.3941 26.1396L25.5221 26.3447C26.2545 26.5205 26.401 26.7842 26.2398 27.5166L24.3941 36.1885C23.9107 38.4297 24.6578 39.4844 26.4156 39.4844C27.7779 39.4844 29.36 38.8545 30.0777 37.9902L30.2975 36.9502C29.7994 37.3896 29.067 37.5654 28.5836 37.5654C27.8951 37.5654 27.6461 37.082 27.8219 36.2324L30.3268 24.4697Z"
        fill="white"
      />
      <path
        d="M30.5 19.25C30.5 20.6307 29.3807 21.75 28 21.75C26.6193 21.75 25.5 20.6307 25.5 19.25C25.5 17.8693 26.6193 16.75 28 16.75C29.3807 16.75 30.5 17.8693 30.5 19.25Z"
        fill="white"
      />
    </svg>
  )
}

export default function InfoAnnotationIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={InfoAnnotationSvg} {...props} />
}
